import http from './http';

export interface EndOfLifeWishesData {
  id?: string;
  ventilatorPreference?: string;
  ventilatorTimeLimit?: string;
  ventilatorNotes?: string;
  feedingTubePreference?: string;
  feedingTubeTimeLimit?: string;
  feedingTubeNotes?: string;
  painManagementPreference?: string;
  painManagementNotes?: string;
  ivFluidsPreference?: string;
  additionalInstructions?: string;
  familyInformed?: boolean;
  isLocked?: boolean;
}

class EndOfLifeWishesService {
  async createEndOfLifeWishes(data: Omit<EndOfLifeWishesData, 'id'>): Promise<EndOfLifeWishesData> {
    const response = await http.post('/api/end-of-life-wishes', data);
    return response.data.data || response.data;
  }

  async updateEndOfLifeWishes(id: string, data: Partial<EndOfLifeWishesData>): Promise<EndOfLifeWishesData> {
    const response = await http.patch(`/api/end-of-life-wishes/${id}`, data);
    return response.data.data || response.data;
  }

  async getEndOfLifeWishesById(id: string, targetUserId?: string): Promise<EndOfLifeWishesData> {
    const url = targetUserId
      ? `/api/end-of-life-wishes/${id}?targetUserId=${targetUserId}`
      : `/api/end-of-life-wishes/${id}`;
    const response = await http.get(url);
    return response.data.data || response.data;
  }

  async getAllEndOfLifeWishes(targetUserId?: string): Promise<EndOfLifeWishesData[]> {
    const url = targetUserId
      ? `/api/end-of-life-wishes?targetUserId=${targetUserId}`
      : '/api/end-of-life-wishes';
    const response = await http.get(url);
    return response.data.data || response.data;
  }

  async deleteEndOfLifeWishes(id: string): Promise<void> {
    await http.delete(`/api/end-of-life-wishes/${id}`);
  }

  async lockEndOfLifeWishes(id: string): Promise<void> {
    await http.post(`/api/end-of-life-wishes/${id}/lock`);
  }

  async unlockEndOfLifeWishes(id: string, emails: string[]): Promise<void> {
    await http.post(`/api/end-of-life-wishes/${id}/unlock`, { emails });
  }

  async getEndOfLifeWishesAccessGrants(id: string): Promise<any[]> {
    const response = await http.get(`/api/end-of-life-wishes/${id}/access-grants`);
    return response.data.data || response.data;
  }
}

export const endOfLifeWishesService = new EndOfLifeWishesService();
